import cn from 'classnames';
import { FC, useMemo } from 'react';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/common/Typography';
import { SignupSlider } from 'src/pages/Signup/SignupSlider';
import { CmsLoginPageResponse } from 'src/types/cms/cmsPageTypes';
import '../styles.scss';

interface IProps {
  loginPage: CmsLoginPageResponse | null;
  device: string;
  modalTitle: string;
  modalContentsMap: { [key: string]: any };
  content: string | null;
}

const ContentWithImage: FC<IProps> = ({ loginPage, device, content, modalTitle, modalContentsMap }) => {
  const { t }: Translation = useTranslation();
  const isPapi = process.env.REACT_APP_WEBSITENAME === 'PapiGames';

  const image = useMemo(() => {
    if (content !== 'forgot' && !isTablet && loginPage?.result?.content) {
      const images =
        device === 'mobile'
          ? loginPage.result.content.pageFields.bannersMobile?.map((banner) => banner.asset.path) || []
          : loginPage.result.content.pageFields.bannersDesktop?.map((banner) => banner.asset.path) || [];

      if (images.length > 0) {
        return (
          <div
            className={cn('content_img', {
              mobile_content_img: isMobileOnly && isPapi,
            })}
          >
            <SignupSlider images={images} />
          </div>
        );
      }
    }

    return null;
  }, [content, loginPage, device]);

  if (isMobileOnly) {
    return (
      <div className="content_with_image_wrapper">
        {image}
        <div className="right_content">
          {modalTitle && (
            <Typography variant={'h4'} className="title">
              {t(modalTitle + '_modal_title')}
            </Typography>
          )}
          {modalContentsMap[content as string]}
        </div>
      </div>
    );
  }

  return (
    <div className="content_with_image_wrapper">
      {image}
      <div className="form">
        {modalTitle && (
          <Typography variant={'h4'} className="title">
            {t(modalTitle + '_modal_title')}
          </Typography>
        )}
        {modalContentsMap[content as string]}
      </div>
    </div>
  );
};

export default ContentWithImage;
